package org.example.project.manager

import kotlinx.browser.window
import kotlinx.coroutines.await
import org.example.project.service.LoginService
import org.w3c.fetch.Headers
import org.w3c.fetch.RequestInit

object LumaticaApiManager {
    val registeredApis: Map<String, String> = mapOf(
        "abrechnung" to "api_abrechnung",
        "bereich" to "api_bereich",
        "chatmodulescreen" to "api_chatmodulescreen",
        "kontakte" to "api_kontakte",
        "linkedinvertriebsindex" to "api_linkedinvertriebsindex",
        "linkedinflow" to "api_linkedinflow",
        "kontrolle" to "api_kontrolle",
        "crangebot" to "api_crangebot",
        "crannahme" to "api_crannahme",
        "crauskunft" to "api_crauskunft",
        "crticket" to "api_crticket",
        "crzustand" to "api_crzustand",
        "userverwaltung" to "api_userverwaltung",
        "websitebuilder" to "api_websitebuilder",
        "webseitenuebersicht" to "api_webseitenuebersicht",
        "desktoploginscreen" to "api_desktoploginscreen",
        "desktopregistrierungscreen" to "api_desktopregistrierungscreen",
        "driverauftraege" to "api_driverauftraege",
        "eingangsbelege" to "api_eingangsbelege",
        "finanzdashboard" to "api_finanzdashboard",
        "feedcontrol" to "api_feedcontrol",
        "firmenregister" to "api_firmenregister",
        "firmenstamm" to "api_firmenstamm",
        "infrastruktur" to "api_infrastruktur",
        "kalender" to "api_kalender",
        "kartei" to "api_kartei",
        "karteiseitenverwaltungscreen" to "api_karteiseitenverwaltungscreen",
        "kundenverbrauch" to "api_kundenverbrauch",
        "kunensetup" to "api_kunensetup",
        "lizenz" to "api_lizenz",
        "loginjournal" to "api_loginjournal_screen",
        "mobilefahrerregistrierungscreen" to "api_mobilefahrerregistrierungscreen",
        "mobileloginscreen" to "api_mobileloginscreen",
        "mobileansichten" to "api_mobileansichten",
        "moduleditor" to "api_moduleditor",
        "meinefahrzeuge" to "api_meinefahrzeuge",
        "nodeuebersicht" to "api_nodeuebersicht",
        "notepadsystem" to "api_notepadsystem",
        "palettenkonto" to "api_palettenkonto",
        "passwortreset" to "api_passwortreset",
        "personalakte" to "api_personalakte",
        "vertriebsindex" to "api_vertriebsindex",
        "profil" to "api_profil",
        "profilverwaltung" to "api_profilverwaltung",
        "registrierung" to "api_registrierung",
        "rollenverwaltung" to "api_rollenverwaltung",
        "screenanzeigemodus" to "api_screenanzeigemodus",
        "screenumgebung" to "api_screenumgebung",
        "schulung" to "api_schulung",
        "screenlizenzverwaltung" to "api_screenlizenzverwaltung",
        "servicedocumentscreen" to "api_servicedocumentscreen",
        "setup" to "api_setup",
        "slot" to "api_slot",
        "slot_we_single" to "api_slot_we_single",
        "slot_we_multi" to "api_slot_we_multi",
        "slot_wa_single" to "api_slot_wa_single",
        "slot_wa_multi" to "api_slot_wa_multi",
        "slotpriorisierung" to "api_slotpriorisierung",
        "snap" to "api_snap",
        "supportabschluss" to "api_supportabschluss",
        "supportauskunftscreen" to "api_supportauskunftscreen",
        "supportki" to "api_supportki",
        "supportticket" to "api_supportticket",
        "syscrscreen" to "api_syscrscreen",
        "sysdashboardauskunft" to "api_sysdashboardauskunft",
        "syssupportscreen" to "api_syssupportscreen",
        "tabularcreator" to "api_tabularcreator",
        "torvergabe" to "api_torvergabe",
        "unternehmenstamm" to "api_unternehmenstamm",
        "personalkontingent" to "api_personalkontingent",
        "user" to "api_user",
        "userverwaltung" to "api_userverwaltung",
        "yard" to "api_yard",
        "yardabschluss" to "api_yardabschluss",
        "yardengine" to "api_yardengine",
        "zeiterfassung" to "api_zeiterfassung",
        "zustand" to "api_zustand"
    )

    suspend fun call(api: String): String {
        val cleanApi = api.trimStart('/')
        val apiName = cleanApi.substringBefore('/')
        require(apiName in registeredApis) { "API nicht registriert: $apiName" }

        val url = "${LumaticaApiSettings.getBaseUrl()}/api/$cleanApi"
        val response = window.fetch(
            url,
            RequestInit(headers = auditHeaders())
        ).await()
        val text = response.text().await()
        if (!response.ok) {
            console.error("Lumatica API failed", apiName, response.status, url, text)
        }
        return text
    }

    suspend fun postJson(api: String, body: String): String {
        val cleanApi = api.trimStart('/')
        val apiName = cleanApi.substringBefore('/')
        require(apiName in registeredApis) { "API nicht registriert: $apiName" }

        val url = "${LumaticaApiSettings.getBaseUrl()}/api/$cleanApi"
        val response = window.fetch(
            url,
            RequestInit(
                method = "POST",
                headers = auditHeaders("application/json"),
                body = body
            )
        ).await()
        val text = response.text().await()
        if (!response.ok) {
            console.error("Lumatica API failed", apiName, response.status, url, text)
        }
        return text
    }

    fun auditHeaders(contentType: String? = null) = Headers().apply {
        if (!contentType.isNullOrBlank()) append("Content-Type", contentType)
        val actor = LoginService.getKuerzel()
        if (actor.isNotBlank()) append("x-user-kuerzel", actor)
        val userId = LoginService.getId()
        if (userId.isNotBlank()) append("x-user-id", userId)
        val firmenId = LoginService.getFirmenId()
        if (firmenId.isNotBlank()) append("x-firmen-id", firmenId)
    }
}
